const initialState = {
  route: 'LOGIN',
  tab: 'EMAIL'
}
export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LOGIN':
      return {...state, route: action.route, tab: action.tab, data: action.data}
    case  'SET_TOKEN':
      return {...state, route: action.route, tab: action.tab, data: action.data}
        case  'SET_CONSENT':
      return {...state, route: action.route, tab: action.tab, data: action.data}
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/layout.js